import React from 'react';
import { Rocket } from 'lucide-react';
import { useLanguage } from '../../assets/js/LanguageContext';
import IconTile from '../common/IconTile';

const AboutUs_1 = () => {
  const { t } = useLanguage();

  return (
    <section className="section-band">
      <div className="section-band__inner tp-about-split">
        <div className="tp-about-split__copy">
          <p className="tp-about-statement tp-about-statement--xl">
            {t('aboutus_efficiency_text1')}{' '}
            <span className="tp-about-accent">{t('aboutus_efficiency_highlight1')}</span>{' '}
            {t('aboutus_efficiency_text2')}{' '}
            <span className="tp-about-accent">{t('aboutus_efficiency_highlight2')}</span>.
          </p>
        </div>
        <div className="tp-about-split__media">
          <IconTile
            accent="#2563EB"
            icon={<Rocket size="1em" strokeWidth={1.25} />}
            className="tp-icon-tile--sm"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutUs_1;
